import { List, Map } from 'immutable';

const prefix = ['app', 'appeals', 'appeals'];

export const currentAppealYearSelector = state =>
  state.getIn([...prefix, 'currentAppealYear']);

export const searchResultsSelector = state =>
  state.getIn([...prefix, 'appealsSearch', 'data'], List([])).toJS();

export const lastSearchSelector = state =>
  state.getIn([...prefix, 'lastSearch']);

export const searchModifierSelector = state =>
  state.getIn([...prefix, 'searchModifier']);

export const appealsUpdateConfigDataSelector = state =>
  state.getIn([...prefix, 'appealsUpdateConfig', 'data']).toJS();

export const searchConfigResultsSelector = state =>
  state.getIn([...prefix, 'searchConfigResults', 'data']).toJS();
export const searchConfigResultsStateSelector = state =>
  state.getIn([...prefix, 'searchConfigResults']).toJS().state;

export const codeFileSelector = state =>
  state.getIn([...prefix, 'codeFiles', 'data'], Map({})).toJS();

export const appraisersSelector = state =>
  state.getIn([...prefix, 'appraisers', 'data'], List([])).toJS();

export const usersSelector = state =>
  state.getIn([...prefix, 'users', 'data'], List([])).toJS();

export const searchResultsStateSelector = state =>
  state.getIn([...prefix, 'appealsSearch']).toJS().state;

export const searchPaginationSelector = state =>
  state.getIn([...prefix, 'pagination']).toJS();

export const appealsHeaderSelector = state =>
  state.getIn([...prefix, 'appealsHeader', 'data'], Map({})).toJS();

export const appealsSummarySelector = state =>
  state.getIn([...prefix, 'appealsSummary', 'data'], Map({})).toJS();

export const appealsSummaryStateSelector = state =>
  state.getIn([...prefix, 'appealsSummary']).toJS().state;

export const appealGeneralInfoSelector = state =>
  state.getIn([...prefix, 'appealGeneralInfo', 'data'], Map({})).toJS();

export const appealGeneralInfoStateSelector = state =>
  state.getIn([...prefix, 'appealGeneralInfo']).toJS().state;

export const appealReasonsSelector = state =>
  state.getIn([...prefix, 'appealReasons', 'data'], Map({})).toJS();

export const appealTagsSelector = state =>
  state.getIn([...prefix, 'appealTags', 'data'], Map({})).toJS();

export const claimantInfoSelector = state =>
  state.getIn([...prefix, 'claimant', 'data'], Map({})).toJS();

export const affidavitInfoSelector = state =>
  state.getIn([...prefix, 'affidavits', 'data'], Map({})).toJS();

export const dueDiligenceSelector = state =>
  state.getIn([...prefix, 'dueDiligence', 'data'], Map({})).toJS();

export const informalSelector = state =>
  state.getIn([...prefix, 'informal', 'data'], Map({})).toJS();

export const priorYrCommentsSelector = state =>
  state.getIn([...prefix, 'priorYrComments', 'data'], Map({})).toJS();

export const formalSelector = state =>
  state.getIn([...prefix, 'formal', 'data'], Map({})).toJS();

export const finalValuesSelector = state =>
  state.getIn([...prefix, 'finalValues', 'data'], Map({})).toJS();

export const globalDocumentsSelector = state =>
  state.getIn([...prefix, 'globalDocuments', 'data'], List([])).toJS();

export const presentationDocumentsSelector = state =>
  state.getIn([...prefix, 'presentationDocuments', 'data'], List([])).toJS();

export const appealPresentationSelector = state =>
  state.getIn([...prefix, 'appealPresentation', 'data'], List([])).toJS();

export const appealStaffSelector = state =>
  state.getIn([...prefix, 'appealStaff', 'data'], List([])).toJS();

export const appealDocumentsSelector = state =>
  state.getIn([...prefix, 'appealDocuments', 'data'], List([])).toJS();

export const newAppealSelector = state =>
  state.getIn([...prefix, 'newInsertedAppeal', 'data'], List([])).toJS();

export const casePrepSelector = state =>
  state.getIn([...prefix, 'casePrep', 'data'], Map({})).toJS();

export const panelsSelector = state =>
  state.getIn([...prefix, 'panels', 'data'], List([])).toJS();

export const panelsStateSelector = state =>
  state.getIn([...prefix, 'panels', 'state']);

export const panelStateSelector = state =>
  state.getIn([...prefix, 'panel', 'state']);

export const incomeActualStateSelector = state =>
  state.getIn([...prefix, 'incomeActual', 'state']);

export const incomeModelStateSelector = state =>
  state.getIn([...prefix, 'incomeModel', 'state']);

export const incomeActualSelector = state =>
  state.getIn([...prefix, 'incomeActual', 'data'], Map({})).toJS();

export const incomeModelSelector = state =>
  state.getIn([...prefix, 'incomeModel', 'data'], Map({})).toJS();

export const panelDataSelector = state =>
  state.getIn([...prefix, 'panel', 'data'], Map({})).toJS();

export const panelBoardMembersSelector = state =>
  state.getIn([...prefix, 'panelBoardMembers', 'data'], List([])).toJS();

export const panelBoardMembersStateSelector = state =>
  state.getIn([...prefix, 'panelBoardMembers', 'state']);

export const appealPanelBoardMemberDataSelector = state =>
  state.getIn([...prefix, 'panelBoardMember', 'data'], Map({})).toJS();

export const appealPanelBoardMemberStateSelector = state =>
  state.getIn([...prefix, 'panelBoardMember', 'state']);

export const activitiesSelector = state =>
  state.getIn([...prefix, 'activity', 'data'], List([])).toJS();

export const activitiesStateSelector = state =>
  state.getIn([...prefix, 'activity', 'state']);

export const appealBoardMembersStateSelector = state =>
  state.getIn([...prefix, 'appealBoardMembers', 'state']);

export const appealBoardMembersDataSelector = state =>
  state.getIn([...prefix, 'appealBoardMembers', 'data'], List([])).toJS();

export const appealBoardMemberStateSelector = state =>
  state.getIn([...prefix, 'appealBoardMember', 'state']);

export const appealBoardMemberDataSelector = state =>
  state.getIn([...prefix, 'appealBoardMember', 'data'], Map({})).toJS();

export const codeFileOfficerPositionsDataSelector = state =>
  state.getIn([...prefix, 'codeFileOfficerPositions', 'data'], List([])).toJS();

export const codeFileRolesDataSelector = state =>
  state.getIn([...prefix, 'codeFileRoles', 'data'], List([])).toJS();

export const codeFilePreferredCommunicationDataSelector = state =>
  state
    .getIn([...prefix, 'codeFilePreferredCommunication', 'data'], List([]))
    .toJS();

export const panelRolesDataSelector = state =>
  state.getIn([...prefix, 'panelRoles', 'data'], List([])).toJS();

export const appealStaffRolesSelector = state =>
  state.getIn([...prefix, 'appealStaffRoles', 'data'], List([])).toJS();

export const appealPanelCadStaffsStateSelector = state =>
  state.getIn([...prefix, 'appealPanelCadStaffs', 'state']);

export const appealPanelCadStaffsDataSelector = state =>
  state.getIn([...prefix, 'appealPanelCadStaffs', 'data'], List([])).toJS();

export const appealPanelCadStaffStateSelector = state =>
  state.getIn([...prefix, 'appealPanelCadStaff', 'state']);

export const appealPanelCadStaffDataSelector = state =>
  state.getIn([...prefix, 'appealPanelCadStaff', 'data'], Map({})).toJS();

export const appealDecisionAuthoritySelector = state =>
  state.getIn([...prefix, 'appealDecisionAuthority', 'data'], List([])).toJS();

export const appealDecisionCodeSelector = state =>
  state.getIn([...prefix, 'appealDecisionCode', 'data'], List([])).toJS();

export const appealDecisionReasonSelector = state =>
  state.getIn([...prefix, 'appealDecisionReason', 'data'], List([])).toJS();

export const appealRecommendationReasonSelector = state =>
  state
    .getIn([...prefix, 'appealRecommendationReason', 'data'], List([]))
    .toJS();

export const appealSearchParamsSelector = state =>
  state.getIn([...prefix, 'searchParams', 'data']).toJS();
export const appealSearchParamsStateSelector = state =>
  state.getIn([...prefix, 'searchParams']).toJS().state;

export const appealSearchParamSelector = state =>
  state.getIn([...prefix, 'searchParam', 'data']).toJS();
export const appealSearchParamStateSelector = state =>
  state.getIn([...prefix, 'searchParam']).toJS().state;

export const appealRecommendationsSelector = state =>
  state.getIn([...prefix, 'appealRecommendations', 'data'], List([])).toJS();
export const appealRecommendationsStateSelector = state =>
  state.getIn([...prefix, 'appealRecommendations', 'state']);

export const recommendationValuesSelector = state =>
  state.getIn([...prefix, 'recommendationValues', 'data'], List([])).toJS();

export const appealRecommendationSelector = state =>
  state.getIn([...prefix, 'appealRecommendation', 'data'], Map({})).toJS();
export const appealRecommendationStateSelector = state =>
  state.getIn([...prefix, 'appealRecommendation', 'state']);

export const printCardSelector = state => state.getIn([...prefix, 'printCard']);

export const statusCodesSelector = state =>
  state.getIn([...prefix, 'statusCodes', 'data'], List([])).toJS();
export const statusCodesStateSelector = state =>
  state.getIn([...prefix, 'statusCodes', 'state']);

export const appealStatusConfigStateSelector = state =>
  state.getIn([...prefix, 'appealStatusConfigState', 'data'], List([])).toJS();

export const appealModuleReportsSelector = state =>
  state.getIn([...prefix, 'appealModuleReports', 'data'], List([])).toJS();

export const appealStatusSelector = state =>
  state.getIn([...prefix, 'appealStatus', 'data'], Map({})).toJS();
export const appealStatusStateSelector = state =>
  state.getIn([...prefix, 'appealStatus', 'state']);

export const appealStatisticsSelector = state =>
  state.getIn([...prefix, 'appealsStatistics', 'data'], Map({})).toJS();
export const appealStatisticsStateSelector = state =>
  state.getIn([...prefix, 'appealsStatistics', 'state']);
export const panelStatisticsSelector = state =>
  state.getIn([...prefix, 'panelStatistics', 'data'], List([])).toJS();
export const panelStatisticsStateSelector = state =>
  state.getIn([...prefix, 'panelStatistics', 'state']);
export const panelStatisticsParametersSelector = state =>
  state.getIn([...prefix, 'panelStatistics', 'parameters']);
export const finalLetterHistorySelector = state =>
  state.getIn([...prefix, 'finalLetterHistory', 'data'], List([])).toJS();
export const finalLetterHistoryRecordsSelector = state =>
  state.getIn([...prefix, 'finalLetterHistory', 'totalRecords']);
export const finalLetterHistoryStateSelector = state =>
  state.getIn([...prefix, 'finalLetterHistory', 'state']);
export const massFinalizeHistorySelector = state =>
  state.getIn([...prefix, 'massFinalizeHistory', 'data'], List([])).toJS();

export const massFinalizeHistoryRecordsSelector = state =>
  state.getIn([...prefix, 'massFinalizeHistory', 'totalRecords']);
export const massFinalizeHistoryStateSelector = state =>
  state.getIn([...prefix, 'massFinalizeHistory', 'state']);
export const massAppealLetterHistorySelector = state =>
  state.getIn([...prefix, 'massAppealLetterHistory', 'data'], List([])).toJS();

export const massAppealLetterHistoryRecordsSelector = state =>
  state.getIn([...prefix, 'massAppealLetterHistory', 'totalRecords']);
export const massAppealLetterHistoryStateSelector = state =>
  state.getIn([...prefix, 'massAppealLetterHistory', 'state']);
export const appealSearchLastPayloadSelector = state =>
  state.getIn([...prefix, 'appealsSearchLastPayload', 'data'], List([])).toJS();
export const massProcessHistorySelector = state =>
  state.getIn([...prefix, 'massProcessHistory', 'data'], List([])).toJS();
export const massProcessHistoryRecordsSelector = state =>
  state.getIn([...prefix, 'massProcessHistory', 'totalRecords']);
export const massProcessHistoryStateSelector = state =>
  state.getIn([...prefix, 'massProcessHistory', 'state']);
export const massProcessEntriesSelector = state =>
  state.getIn([...prefix, 'massProcessEntries', 'data'], List([])).toJS();
export const massAttachHistorySelector = state =>
  state.getIn([...prefix, 'massAttachHistory', 'data'], List([])).toJS();
export const massAttachHistoryRecordsSelector = state =>
  state.getIn([...prefix, 'massAttachHistory', 'totalRecords']);
export const massAttachHistoryStateSelector = state =>
  state.getIn([...prefix, 'massAttachHistory', 'state']);
export const evidenceUploadHistorySelector = state =>
  state.getIn([...prefix, 'evidenceUploadHistory', 'data'], List([])).toJS();
export const evidenceUploadHistoryRecordsSelector = state =>
  state.getIn([...prefix, 'evidenceUploadHistory', 'totalRecords']);
export const evidenceUploadHistoryStateSelector = state =>
  state.getIn([...prefix, 'evidenceUploadHistory', 'state']);
export const evidenceImportPropertiesSelector = state =>
  state.getIn([...prefix, 'evidenceImportProperties', 'data'], List([])).toJS();
export const evidenceImportPropertiesStateSelector = state =>
  state.getIn([...prefix, 'evidenceImportProperties', 'state']);
export const massDownloadHistorySelector = state =>
  state.getIn([...prefix, 'massDownloadHistory', 'data'], List([])).toJS();
export const massDownloadHistoryRecordsSelector = state =>
  state.getIn([...prefix, 'massDownloadHistory', 'totalRecords']);
export const massDownloadHistoryStateSelector = state =>
  state.getIn([...prefix, 'massDownloadHistory', 'state']);
export const massAoaHistorySelector = state =>
  state.getIn([...prefix, 'massAoaHistory', 'data'], List([])).toJS();
export const massAoaHistoryRecordsSelector = state =>
  state.getIn([...prefix, 'massAoaHistory', 'totalRecords']);
export const massAoaHistoryStateSelector = state =>
  state.getIn([...prefix, 'massAoaHistory', 'state']);

export const massAoaPropertyListSelector = state =>
  state.getIn([...prefix, 'massProperties', 'data'], List([])).toJS();
export const massAoaPropertyListStateSelector = state =>
  state.getIn([...prefix, 'massProperties', 'state']);

export const autoPacketStatusSelector = state =>
  state.getIn([...prefix, 'autoPacketStatus', 'data'], Map({})).toJS();
export const autoPacketStatusStateSelector = state =>
  state.getIn([...prefix, 'autoPacketStatus', 'state']);

export const appealEventsSelector = state => state.getIn([...prefix, 'events']);
export const appealTaxingUnitsSelector = state =>
  state.getIn([...prefix, 'taxingUnits'], List([])).toJS();

export const panelDocketGroupsSelector = state =>
  state.getIn([...prefix, 'panelDocketGroups', 'data'], List([])).toJS();
export const panelDocketGroupsStateSelector = state =>
  state.getIn([...prefix, 'panelDocketGroups', 'state']);

export const panelWaitingRoomsSelector = state =>
  state.getIn([...prefix, 'panelWaitingRooms', 'data'], List([])).toJS();
export const panelWaitingRoomsStateSelector = state =>
  state.getIn([...prefix, 'panelWaitingRooms', 'state']);

export const appealSearchFormValueSelector = state =>
  state.getIn(['form', 'appealsSearch']);

export const appealSearchFormDataSelector = state =>
  state.getIn([...prefix, 'appealSearchFormData']).toJS();

export const waitingRoomSelectedInformalSelector = state =>
  state.getIn([...prefix, 'selectedInformalWaitingRoom']);
export const waitingRoomSelectedFormalSelector = state =>
  state.getIn([...prefix, 'selectedFormalWaitingRoom']);
export const panelOverviewSelectedTypeSelector = state =>
  state.getIn([...prefix, 'selectedPanelType']);

export const appealConfigurationSelector = state =>
  state.getIn([...prefix, 'appealConfiguration', 'data'], Map({})).toJS();
export const appealConfigurationStateSelector = state =>
  state.getIn([...prefix, 'appealConfiguration', 'state']);

export const massProcessHistoryPropertyListSelector = state =>
  state.getIn([...prefix, 'massProcessHistoryPropertyList', 'data'], List([])).toJS();
export const massProcessHistoryPropertyListRecordsSelector = state =>
  state.getIn([...prefix, 'massProcessHistoryPropertyList', 'totalRecords']);
export const massProcessHistoryPropertyListStateSelector = state =>
  state.getIn([...prefix, 'massProcessHistoryPropertyList', 'state']);

export const massProcessHistoryErrorsSelector = state =>
  state.getIn([...prefix, 'massProcessHistoryErrors', 'data'], List([])).toJS();
export const massProcessHistoryErrorsRecordsSelector = state =>
  state.getIn([...prefix, 'massProcessHistoryErrors', 'totalRecords']);
export const massProcessHistoryErrorsStateSelector = state =>
  state.getIn([...prefix, 'massProcessHistoryErrors', 'state']);

export const formalVCRecordingsSelector = state =>
  state.getIn([...prefix, 'formalVCRecordings', 'data'], List([])).toJS();
export const formalVCRecordingsStateSelector = state =>
  state.getIn([...prefix, 'formalVCRecordings', 'state']);